<template>
  <div class="userlist">

      <b-row>
        <b-col>
            <component @rowadded="rowadded" @editexit="editexit" @refreshlist="refreshlist" v-bind:is="currentView" ref="myCom"></component>
        </b-col>
      </b-row>

      <!-- SPACER-->
      <spacer-card></spacer-card>
      <!-- SPACER-->

      <b-row>
        <b-col>
          <users-table ref="usersTable" @rowedit="rowedit"></users-table>
        </b-col>
      </b-row>

  </div>
</template>

<script>
/*
refs, and $refs, are not reactive.

If you want to pick up the updated value, you should wait until
the next render cycle updates the DOM.

*/

import Usersadd from '@/components/users/UsersAdd';
import Usersedit from '@/components/users/UsersEdit';
import Userstable from '@/components/users/UsersTable';
import Spacer from '@/components/card/Spacer';

export default {
    data () {
        return {
          currentView: 'users-add'
        }
    },
    methods : {
      rowadded() {
        this.$refs.usersTable.refreshList();
      },

      rowedit(iduser) {
        this.currentView = 'users-edit'
        //Trick to render next DOM element to update ref from dynamic
        //component loaded
        this.$nextTick(() => {
          // DOM updated
          this.$refs.myCom.getUser(iduser);
        })
      },

      editexit() {
        this.currentView = 'users-add'
        this.$refs.usersTable.refreshList();
      },

      refreshlist() {
        this.$refs.usersTable.refreshList();
      }
    },
    components: {
      'users-add': Usersadd,
      'users-edit': Usersedit,
      'users-table': Userstable,
      'spacer-card': Spacer
    }
}
</script>

<style>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
